import { createFileRoute, notFound } from '@tanstack/react-router'

import keycloak from '@/core/keycloak'
import SelfSignup from '@/signup/components/SelfSignup/SelfSignup'

export const Route = createFileRoute('/signup/$slug')({
  beforeLoad: async () => {
    if (keycloak.authenticated) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SelfSignup />
}
